/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Mitarbeiterdaten1Inputs */



/**

* @param {_Field_Mitarbeiterdaten1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_mitarbeiterdaten1 = /** @type {((inputs?: _Field_Mitarbeiterdaten1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Mitarbeiterdaten1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Mitarbeiterdaten")
});
export { _field_mitarbeiterdaten1 as "_field_mitarbeiterDaten" }